import { render } from "./MontaCrud.vue?vue&type=template&id=81c8ac1e&scoped=true"
import script from "./MontaCrud.vue?vue&type=script&lang=js"
export * from "./MontaCrud.vue?vue&type=script&lang=js"

import "./MontaCrud.vue?vue&type=style&index=0&id=81c8ac1e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c8ac1e"]])

export default __exports__